export default "__VITE_ASSET__8927e22a__"